import { useEffect, useRef } from "react";
/**
 * Subscribes once to the client's 403 `mfa_required` event (#1501) and calls `onRequired`, so any
 * page can route to enrolment with a message. Tolerates clients without the hook (older bridge,
 * test stubs). Returns nothing; the subscription ends on unmount.
 */
export function useMfaRequired(client, onRequired) {
    const latest = useRef(onRequired);
    latest.current = onRequired;
    useEffect(() => {
        if (typeof client.onMfaRequired !== "function")
            return;
        return client.onMfaRequired(() => latest.current());
    }, [client]);
}
/** Message shown on the enrol screen after a refused privileged write. */
export const MFA_REQUIRED_MESSAGE = "That change needs two-step sign-in. Set it up below, then try again.";
//# sourceMappingURL=useMfaRequired.js.map